import { useState, useEffect } from 'react';
import { get } from 'lodash';
import {
  UserSettings,
  Topic,
  Channel,
  Category,
  ChannelConfiguration,
} from '@jupiterone/notification-types';
import {
  useSetUserNotificationSettingsForTopicMutation,
  useUserNotificationSettingsQuery,
} from 'navbar/src/jupiterAccountSettings/AccountSettings/Notifications/graphql';

export interface SlackChannelConfiguration {
  slackChannels: string[];
  integrationInstanceId: string;
}

// We currently are setting the same Slack configuration for each Topic
const getSlackConfiguration = (userSettings: UserSettings) => {
  return get(userSettings, [
    Category.INTEGRATIONS,
    Topic.INTEGRATION_FAILURE,
    Channel.SLACK,
  ]);
};

const useNotificationSettings = () => {
  const [
    slackConfiguration,
    setSlackConfiguration,
  ] = useState<SlackChannelConfiguration>();

  const {
    data: notificationSettingsData,
    loading,
    refetch,
  } = useUserNotificationSettingsQuery();
  const notificationSettings =
    notificationSettingsData?.userNotificationSettings;

  // Extract existing Slack configuration
  useEffect(() => {
    if (notificationSettings) {
      setSlackConfiguration(getSlackConfiguration(notificationSettings));
    }
  }, [notificationSettings]);
  const [
    mutate,
    { loading: loadingMutation },
  ] = useSetUserNotificationSettingsForTopicMutation();

  const handleUpsertNotificationSettings = async ({
    topic,
    channelConfigurationUpdate,
  }: {
    topic: Topic;
    channelConfigurationUpdate: ChannelConfiguration;
  }) => {
    await mutate({
      variables: { update: { topic, channelConfigurationUpdate } },
    });
  };
  return {
    loading,
    loadingMutation,
    slackConfiguration,
    notificationSettings,
    handleUpsertNotificationSettings,
    refetchNotificationSettings: refetch,
  };
};

export default useNotificationSettings;
